module.exports = __webpack_public_path__ + "img/meter.845f8ee6.svg";